import { makeStyles } from '@material-ui/core'

import { getDirection } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  tabPanel: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  },
  topBar: {
    height: 48,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 16,
    boxShadow: 'none',
    borderBottom: '1px solid #dbdbdb',
    [theme.breakpoints.down('sm')]: { paddingLeft: 0 }
  },
  tabs: {
    maxWidth: 'calc(100vw - 100px)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100vw)'
    }
  },
  backIcon: {
    transform: `rotate(${getDirection() === 'rtl' ? '180deg' : '0deg'})`
  }
}))

export default useStyles
